import { Injectable } from '@angular/core';
import { PemField } from '@frontend-site/pem/domain';

@Injectable({ providedIn: 'root' })
export class EntitySubListFieldsService {
    public getOrderedGridFields(allFields: PemField[]): PemField[] {
        const filteredFields = allFields.filter((field) => {
            if (field.entityListData?.excludeFromGridColumns) {
                return false;
            }
            return field.customField || field.displayable;
        });

        const standardFields = filteredFields.filter((f) => !f.customField);
        const customFields = filteredFields.filter((f) => f.customField);

        standardFields.sort(this.sortByOrderAndName);
        customFields.sort(this.sortByOrderAndName);

        return [...standardFields, ...customFields];
    }

    public getAgGridFilterType(fieldType: string): string | boolean {
        switch (fieldType) {
            case 'INTEGER':
            case 'FLOAT':
                return 'agNumberColumnFilter';
            case 'DATE':
                return 'agDateColumnFilter';
            case 'BOOLEAN':
            case 'SINGLE_SELECT':
            case 'USER':
                return 'agSetColumnFilter';
            case 'STRING':
            default:
                return 'agTextColumnFilter';
        }
    }

    private sortByOrderAndName(a: PemField, b: PemField): number {
        const orderA = a.order ?? Number.MAX_SAFE_INTEGER;
        const orderB = b.order ?? Number.MAX_SAFE_INTEGER;
        if (orderA !== orderB) {
            return orderA - orderB;
        }
        return (a.visibleName || '').localeCompare(b.visibleName || '');
    }
}
